/* eslint-disable sonarjs/no-duplicate-string */
export const PLACE_CASH_LABELS = 'checkout.placeCashBanner';
export const PLACE_CASH_DYNAMIC_LABELS = 'dynamic.checkout_d';

const PlaceCashBannerLabels = {
  checkout: {
    placeCashBanner: {
      lbl_placeCash_US_bag_subTitle: 'Get #cashAmountOff# for every #placeCashOffer# you spend!',
      lbl_placeCash_CA_bag_subTitle: 'Get #cashAmountOff# for every #placeCashOffer# you spend!',

      lbl_placeCash_US_bag_tnc:
        'Cannot be combined with any other offer. Terms & conditions apply.',
      lbl_placeCash_CA_bag_tnc:
        'Cannot be combined with any other offer. Terms & conditions apply.',
      lbl_placeCash_US_confirmation_tnc:
        '	Confirmation: Cannot be combined with any other offer. Terms & conditions apply.',
      lbl_placeCash_CA_confirmation_tnc:
        'Confirmation: Cannot be combined with any other offer. Terms & conditions apply.',
      lbl_placeCash_US_bag_modalLink: 'See Details',
      lbl_placeCash_CA_bag_modalLink: 'See Details	',
      lbl_placeCash_US_confirmation_modalLink: 'See Details Confirm',
      lbl_placeCash_CA_confirmation_modalLink: 'See Details Confirm',
      lbl_placereward_link_title: 'Learn More',
      lbl_placereward_model_header: 'Place reward',
      lbl_placereward_model_description: 'Place reward desc',
      lbl_placeCash_US_bag_detailModalTitle: 'Place Bucks Detail',
      lbl_placeCash_CA_bag_detailModalTitle: 'Place Bucks Detail',
      lbl_placeCash_US_confirmation_detailModalTitle: 'Place Bucks Detail Confirmation',
      lbl_placeCash_CA_confirmation_detailModalTitle: 'Place Bucks Detail Confirmation',
      lbl_placeCash_US_bag_altName: 'Place Cash Background Image',
      lbl_placeCash_CA_bag_altName: 'Place Cash Background Image',
      lbl_placeCash_US_confirmation_altName: 'Place Cash Background Image',
      lbl_placeCash_CA_confirmation_altName: 'Place Cash Background Image',
      lbl_placeCash_US_bag_title: 'YAY! You’ll Earn #earnedPlaceCashValue# in PLACE Bucks',
      lbl_placeCash_CA_bag_title: 'YAY! You’ll Earn #earnedPlaceCashValue# in PLACE Bucks',
      lbl_placeCash_US_confirmation_title: 'YAY! You’ll Earn #earnedPlaceCashValue# in PLACE Bucks',
      lbl_placeCash_CA_confirmation_title: 'YAY! You’ll Earn #earnedPlaceCashValue# in PLACE Bucks',
    },
  },
};

export default PlaceCashBannerLabels;
